<template>
  <div>
    <v-container container--fluid grid-list-xl>
       <v-row>
        <v-col cols="12" class="justify-center">
          <v-autocomplete
            :items="renderedSuggestedAddresses"
            hide-no-data
            :search-input.sync="val"
            :label="label"
            v-on:keyup.enter="done"
          >
            <template v-slot:append>
              <v-icon color="red" @click="val=''" class="pl-1">
                clear
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
       </v-row>

      <v-row justify="center">
          <v-col cols="6" pt-0 pb-0>
            <v-btn text block color="blue darken-1" @click="done">Search</v-btn>
          </v-col>
       </v-row>

    </v-container>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "AddressSearch",
    props: {
      value: String,
      label: {
        type: String,
        default: "Address"
      }
    },
    data() {
      return {
        val: null
      }
    },
    computed: {
      renderedSuggestedAddresses() {
        if (this.suggestedAddresses === undefined) return [];
        return this.suggestedAddresses;
      }
    },
    asyncComputed: {
      async suggestedAddresses() {
        if (this.val !== null) {
          return await axios.get(process.env.API_URL + '/addressify?action=autocomplete&term=' + this.val.replace(' ', '+') + '&close_matches=true&address_types=2&max_results=20')
            .then((response) => {
              if (response.status === 200) {
                return response.data;
              }
            })
            .catch((error) => {
                return [];
            })
        }
      }
    },
    methods: {
      done() {
        this.$emit('done');
      },
      clear() {
        this.$emit('clear');
      }
    },
    watch: {
      val(val) {
        this.$emit('input', val);
      },
      value(val) {
        this.val = val;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/AddressSearch.vue